import { useState } from 'react';
import cx from 'classnames';
import CopyToClipboard from 'react-copy-to-clipboard';
import { isDesktop, isMobile } from 'react-device-detect';
import { FacebookShareButton, TwitterShareButton } from 'react-share';

import { AppTracker, EventSchema, ShareType } from 'types';
import { getEventURL } from 'utils';
import { tracker } from 'services';
import { Divider } from 'components';
import { CheckedIcon, CopyIcon, FacebookLogoIcon, ThreeDotsIcon, TwitterLogoIcon } from 'components/Icon';

import styles from './SharePanel.module.scss';

export type SharePanelProps = {
  event: EventSchema;
};

const SharePanel = ({ event }: SharePanelProps) => {
  const [copied, setCopied] = useState(false);

  const shareText = `Hey, please join this event to talk about “${event.name}”`;
  const shareLink = getEventURL(event.channelName, event.code, true);

  const handleOnCopied = () => {
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 2_000);
  };

  const handleOnShare = () => {
    try {
      navigator.share({
        url: getEventURL(event.channelName, event.code)
      });
    } catch (e) {
      alert('Not supported');
    }
  };

  const handleOnShareOnFacebook = () => {
    tracker.shareEventLink(event.code, ShareType.FACEBOOK, AppTracker.ShareSource.EVENT_DETAIL_PAGE);
  };

  const handleOnShareOnTwitter = () => {
    tracker.shareEventLink(event.code, ShareType.TWITTER, AppTracker.ShareSource.EVENT_DETAIL_PAGE);
  };

  return (
    <div className={styles.container}>
      {isDesktop && (
        <>
          <div className={styles.row}>
            <TwitterShareButton
              className={styles.twitter}
              title={shareText}
              url={shareLink}
              onClick={handleOnShareOnTwitter}
            >
              <TwitterLogoIcon width={20} height={20} className="mr-6" />
              <span>Twitter</span>
            </TwitterShareButton>
            <FacebookShareButton
              className={styles.facebook}
              title={shareText}
              url={shareLink}
              onClick={handleOnShareOnFacebook}
            >
              <FacebookLogoIcon width={20} height={20} className="mr-6" />
              <span>Facebook</span>
            </FacebookShareButton>
          </div>
          <Divider className={styles.separator} text="Or" />
        </>
      )}

      <div className={styles.row}>
        <CopyToClipboard text={getEventURL(event.channelName, event.code, true)}>
          <button type="button" className={cx(styles.copy, styles.copied)} onClick={handleOnCopied}>
            {copied ? (
              <CheckedIcon width={18} height={18} className="mr-6" />
            ) : (
              <CopyIcon width={18} height={18} className="mr-6" />
            )}
            <span>{copied ? 'Copied' : 'Copy link'}</span>
          </button>
        </CopyToClipboard>
      </div>

      {isMobile && (
        <>
          <Divider className={styles.separator} text="Or" />
          <div className={styles.row}>
            <button type="button" className={styles.more} onClick={handleOnShare}>
              <ThreeDotsIcon width={18} height={18} className="mr-6" />
              <span>More options</span>
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default SharePanel;
